module.exports = __webpack_public_path__ + "24a18e4fec29fb7cfd79d629e85269b9.pdf";